// extracted by mini-css-extract-plugin
module.exports = {"MainHeader":"NavBar_MainHeader__1LfE7"};